import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import './SettingsPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import VolumeSlider from '../../VolumeSlider/VolumeSlider';
import MusicVolumeSlider from '../../MusicVolumeSlider/MusicVolumeSlider';
import FullscreenToggleButton from '../../FullscreenToggleButton/FullscreenToggleButton';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import PasswordChangeModal from '../../Modals/PasswordChangeModal/PasswordChangeModal';
import FloatingBackButton from '../../elements/FloatingBackButton/FloatingBackButton';

const PAGE_ID = 'SettingsPage';

function SettingsPage({onBack}) {
  usePageAnalytics('SettingsPage');
  // Пароль есть только у аккаунтов, заведенных по почте: владельцу Яндекс ID
  // менять нечего, а гостю — тем более (см. hasPassword в /auth/me)
  const hasPassword = useSelector((state) => Boolean(state.private.auth?.hasPassword));
  const [isPasswordChangeOpen, setIsPasswordChangeOpen] = useState(false);

  return (
    <>
      <FloatingBackButton onBack={onBack} pageId={PAGE_ID}/>

      <h1 className="lobby-page-title">Настройки</h1>

      <div className="settings-sliders">
        <VolumeSlider/>
        <MusicVolumeSlider/>
      </div>

      <div className="main-menu-buttons">
        <FullscreenToggleButton className={'settings_full-screen-button'} pageId={PAGE_ID}/>
        {hasPassword && (
          <PageButton
            onClick={() => setIsPasswordChangeOpen(true)}
            pageId={PAGE_ID}
            buttonId="change-password"
          >Сменить пароль</PageButton>
        )}
        <PageButton
          onClick={onBack} pageId="SettingsPage" buttonId="back"
        >Назад</PageButton>
      </div>

      {isPasswordChangeOpen && (
        <PasswordChangeModal onClose={() => setIsPasswordChangeOpen(false)}/>
      )}
    </>
  );
}

export default SettingsPage;
